module.exports = __webpack_public_path__ + "img/网站3-06.7903138f.jpg";